// extracted by css-extract-rspack-plugin
export default {"container":"QuestionBox_container__7-Wly","examples":"QuestionBox_examples__MbIal"};